<!--
树组件，配置方法参考 /pos/center.vue
需要传入的参数有
title, keyName, filterKey, update
-->
<!--suppress JSXNamespaceValidation, HtmlUnknownAttribute -->
<template>
  <div class="i-tree">
    <!--suppress JSUnresolvedVariable -->
    <el-tree ref="tree" :default-expand-all="showPopBox"
             :data="tree"
             node-key="id"
             :expand-on-click-node="false"
             :render-content="showPopBox ? renderContent : undefined"
             :filter-node-method="filterNode"
             :load="loadNode"
             @node-click="handleNodeClick"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {nError, nSuccessFunc, nWarn} from '../../utils/notice'
import {pattern} from '../../utils/regular'
import {createAnErrorWithTip, errorHandler} from '../../utils/errorHandler'

export default {
  name: 'd-tree',
  props: {
    filterKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '标题'
    },
    keyName: {
      type: String,
      default: '键名'
    },
    showPopBox: {
      type: Boolean,
      default: true
    },
    maxDepth: {
      type: Number,
      default: 4
    },
    canChoose: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default () {
        return {
          1: [],
          2: ['add'],
          3: ['add', 'patch', 'delete'],
          4: ['patch', 'delete']
        }
      }
    },
    update: {
      type: Object,
      default () {
        return {
          render: () => [],
          addNode: this._print,
          removeNode: this._print,
          editNode: this._print
        }
      }
    }
  },
  watch: {
    'filterKey' (val) {
      this.$refs.tree.filter(val)
    }
  },
  data () {
    return {
      tree: [],
      treeFromServer: [],
      detailForm: {
        title: '添加营业单位',
        show: false,
        then: () => {
        },
        type: ''
      }
    }
  },
  created () {
    this.render()
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data._label.indexOf(value) !== -1
    },
    render () {
      this.update.render()
        .then(this.convertData)
    },

    convertData (treeFromServer) {
      /**
       * 组装节点
       * @function
       * @param nodes
       */
      const packNode = (nodes) => {
        const getNodes = nodeId =>
          treeFromServer.filter(n => n.parentCode === nodeId)

        nodes.forEach(node => {
          const children = getNodes(node.code)
          node.children = children
          if (children.length > 0) {
            packNode(children)
          }
        })
      }
      /**
       * 格式化原始数据
       */
      treeFromServer
        .forEach(it => {
          it.edidable = false
          it.label = it._label
        })

      /**
       * 生成顶层节点
       */
      const tree = treeFromServer.filter(tree => tree.parentCode == 0)

      /**
       * 开始组装节点
       */
      packNode(tree)

      this.tree = tree
    },

    /* *********
     三种操作
     ********* */
    append (event, node, parentData) {
      if (node.level >= this.maxDepth) {
        nWarn(`最多${this.maxDepth}级`)
        return
      }
      event.stopPropagation()
      const data = {_label: '', children: []}
      if (!parentData.children) {
        this.$set(parentData, 'children', [])
      }
      parentData.children.push(data)
      Vue.nextTick(() => {
        const domNodes = this.getTargetChildDomNode(event.target)
        const domNode = domNodes[domNodes.length - 1]
        this.setEditable(domNode)
        domNode.style.overflow = 'visible'
        domNode.oninput = this.onEnter(domNode)

        new Promise((resolve) => {
          domNode.onblur = resolve
        })
          .then(event => this.checkInput(event, data))
          // 转换
          .then((val) => {
            return {
              _label: val,
              parentCode: parentData.code
            }
          })
          // 发送
          .then(data => this.update.addNode(data))
          .then(() => {
            domNode.innerHTML = ''
          })
          .then(nSuccessFunc('添加成功'))
          .then(this.render)
          .then(() => this.setEditableFalse(domNode))
          .catch(error => {
            errorHandler('请求失败')(error)
            this.render()
          })
      })
    },
    edit (event, data) {
      event.stopPropagation()
      const domNode = this.getTargetDomNode(event.target)
      domNode.style.overflow = 'visible'
      new Promise((resolve) => {
        this.setEditable(domNode)
        domNode.oninput = this.onEnter(domNode)
        domNode.onblur = resolve
      })
        .then(event => this.checkInput(event, data))
        .then((val) => {
          data._label = val
        })
        .then(() => this.update.editNode(data))
        .then(nSuccessFunc('修改成功'))
        .then(this.render)
        .then(() => this.setEditableFalse(domNode))
        .catch(errorHandler('请求失败'))
        .then(() => { domNode.style.overflow = 'hidden' })
    },
    remove (event, {id}) {
      this.$confirm(`确认删除${this.title}`)
        .then(() => this.update.removeNode(id))
        .then(nSuccessFunc('操作成功'))
        .then(this.render)
        .catch(errorHandler('请求失败'))
    },
    getTargetDomNode (domNode) {
      const c = domNode.parentNode.parentNode.parentNode.getElementsByClassName('left')
      if (c.length === 1) {
        return c[0]
      }
    },
    getTargetChildDomNode (domNode) {
      return this.getTargetDomNode(domNode)
        .parentNode.parentNode.parentNode.getElementsByClassName('left')
    },
    onEnter (domNode) {
      return e => {
        const isEnter = e.inputType === 'insertParagraph'
        const isBackward = e.inputType === 'deleteContentBackward'
        const isForward = e.inputType === 'deleteContentForward'
        if (isEnter ||
          (!isBackward && !isForward && e.data === null)
        ) {
          e.target.innerHTML = e.target.innerText.trim()
          domNode.blur()
        }
      }
    },
    checkInput ({target}, data) {
      if (target.innerText === '') {
        target.innerHTML = data._label
        return Promise.reject(createAnErrorWithTip('节点为空'))
      }
      if (target.innerText === data._label) {
        return Promise.reject(createAnErrorWithTip('您好像未做修改', '用户未修改'))
      }
      if (target.innerText.trim().length > 20) {
        return Promise.reject(createAnErrorWithTip('不能超20个字符'))
      }
      if (!pattern.basicAndCN.test(target.innerText.trim())) {
        return Promise.reject(createAnErrorWithTip('只允许包含中文，字母，数字，下划线'))
      }
      return target.innerText
    },
    setEditable (domNode) {
      domNode.contentEditable = true
      domNode.focus()
      const range = getSelection()
      range.selectAllChildren(domNode)
      range.collapseToEnd()
      return domNode
    },
    setEditableFalse (domNode) {
      domNode.contentEditable = false
      domNode.style.overflow = 'visible'
    },
    /* *********
     三种操作 结束
     ********* */
    renderContent (h, {node, data}) {
      let _class
      if (data.type === '1') {
        _class = 'el-icon-date'
      } else if (data.type === '2') {
        _class = 'el-icon-mobile-phone'
      }
      return (
        <span class="item">
          <i class={_class}></i>
          <span class="left">{data._label}</span>
        </span>
      )
    },
    handleNodeClick ($event) {
      if ($event.type !== '2') {
        nError('请选择门禁设备')
        return false
      }
      // const currentId = $event.id
      // const isChecked = this.$refs.tree.getCheckedKeys().includes(currentId)
      // const checkedKeys = isChecked ? [] : [currentId]
      // this.$refs.tree.setCheckedKeys(checkedKeys)
      this.$emit('selected', $event)
    },
    loadNode (node, resolve) {
    }
  }
}
</script>

<style scoped>
.el-tree{
  height: 260px!important;
  overflow-y: auto;
}
</style>

<style lang="less">
  .-the-tree .el-tree-node > .el-tree-node__children {
    overflow: visible!important;
  }
  .el-icon-damai-zuzhijiagou, .el-icon-damai-biaoshilei_menjin, .el-icon-damai-renlianshibie{
    font-size: 14px!important;
    float: left;
    line-height: 25px;
    margin-right: 3px;
  }
  .-the-tree {
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }

    .left {
      display: block;
      min-width: 50px;
      max-width: 100px;
      overflow: hidden;
      margin-left: 3px;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
      &:hover {
        text-overflow: unset;
        max-width: unset;
      }
    }
    .icon-more {
      display: block;
      font-size: 12px;
      color: #999999;
      position: relative;
      padding: 4px;
      overflow: visible;
      margin-right: 60px;
      .pop-box {
        display: none;
        background-color: #fff;
        width: 48px;
        position: absolute;
        top: 10px;
        left: 20px;
        user-select: none;
        z-index: 2018;
      }
      .operate {
        display: none;
        font-size: 12px;
        color: #999999;
        padding: 5px;
        margin-top: -1px;
        border: 1px solid #999999;
      }
      .operate:hover {
        color: #1362FF;
        border: 1px solid #1362FF;
      }
      &.show .pop-box {
        display: block !important;
        .operate {
          display: block !important;
        }
      }
    }
  }
</style>

<style lang="less">
  label {
    margin-bottom: 0 !important;
  }
  .i-tree {
    .el-tree-node {
      .el-tree-node__children {
        overflow: hidden!important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/d-tree.vue